import React from "react";
import Check from "@shared/svg/check.svg?react";
import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import { useScrollToValue } from "./Selector.hooks";

type Props = {
  list: string[];
  onChange: (e: string) => void;
  value: string;
  stylings?: React.CSSProperties;
};

const Selector = ({ stylings, list, onChange, value }: Props) => {
  const { containerRef, itemRefs } = useScrollToValue(value);

  return (
    <div
      ref={containerRef}
      className="no-scrollbar flex flex-col"
      style={{
        height: "284px",
        overflowY: "scroll",
        backgroundColor: "white",
        scrollBehavior: "smooth",
        ...stylings,
      }}
    >
      {list.map((e) => (
        <div
          key={e}
          ref={(el: HTMLDivElement) => (itemRefs.current[e] = el)}
          className={`flex justify-between hover:bg-gray-5 px-3 py-2 min-w-[66px]`}
          onClick={() => {
            onChange(e);
          }}
        >
          <div style={{ marginRight: "8px" }}>
            <BodyText size={BODY_TEXT_SIZES.X_SMALL}>{e}</BodyText>
          </div>
          {value === e && <Check className="text-brand" />}
        </div>
      ))}
    </div>
  );
};

export default Selector;
